import React from 'react';
const WordHeaderReflexive = ({ caseValue, className = '' }) => {
  if (!caseValue) return null;

  const v = (caseValue || '').toLowerCase();
  const isDative = v === 'dative' || v === 'dativ';

  const colorClass = isDative
    ? 'text-[var(--das-text)]'
    : 'text-[var(--ink-900)]';

  const textColor = isDative ? 'var(--das)' : 'var(--ink-900)';

  return (
    <span className={`${className} font-semibold`} style={{ color: textColor }}>
      {isDative ? 'sich (+D)' : 'sich'}
    </span>
  );
};

export default WordHeaderReflexive;
